import { DateTime } from "luxon";

export function formatDate(
  format: "WEEKDAYS" | "HOURS" | "DATES",
  date: DateTime
): { title: string; subtitle: string } {
  switch (format) {
    case "DATES":
      return {
        title: date.toLocaleString({
          day: "numeric",
        }),
        subtitle: date.toLocaleString({ month: "long" }),
      };
    case "HOURS":
      return {
        title: date.toLocaleString(DateTime.TIME_24_SIMPLE),
        subtitle: date.toLocaleString({ day: "numeric", month: "short" }),
      };
    case "WEEKDAYS":
      return {
        title: date.toLocaleString({ weekday: "short" }),
        subtitle: date.toLocaleString({ day: "numeric", month: "short" }),
      };
  }
}
